import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const CashFreePaymentPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [cashFreePaymentConfig, setCashFreePaymentConfig] = useState<any>({
    isEnabled: true,
    isEnabledIos: true,
    secret_key: '',
    api_key: '',
    isTestMode: true,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    if (name !== 'isEnabled' && name !== 'isEnabledIos' && name !== 'isTestMode') {
      setCashFreePaymentConfig({...cashFreePaymentConfig, [name]: event.target.value})
      // if (event.target.value.length !== 0) {
      //   updateConfiguration({...cashFreePaymentConfig, [name]: event.target.value})
      // }
    } else {
      setCashFreePaymentConfig({...cashFreePaymentConfig, [name]: value})
      updateConfiguration({...cashFreePaymentConfig, [name]: value})
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(cashFreePaymentConfig)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('cashfree')
    if (result.success) {
      let parsedData = result.data.values
      setConfigId(result.data._id)
      setCashFreePaymentConfig({
        isEnabled: parsedData?.isEnabled,
        isEnabledIos: parsedData?.isEnabledIos,
        api_key: parsedData?.api_key,
        secret_key: parsedData?.secret_key,
        isTestMode: parsedData?.isTestMode,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Cash Free plugin</strong>
            </p>
            <p className='text-muted'>Enable or disable Cash Free plugin</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isEnabled'
                checked={cashFreePaymentConfig.isEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable IOS Cash Free plugin</strong>
            </p>
            <p className='text-muted'>Enable or disable IOS Cash Free plugin</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isEnabledIos'
                checked={cashFreePaymentConfig.isEnabledIos}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'> Api Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='api_key'
                value={cashFreePaymentConfig.api_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'> Secret Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='secret_key'
                value={cashFreePaymentConfig.secret_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Test Mode</strong>
            </p>
            <p className='text-muted'>
              Enable or disable Test Mode using this toggle. Only the cash free verify URL will be
              changed.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isTestMode'
                checked={cashFreePaymentConfig.isTestMode}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CashFreePaymentPlugin
